var _rect, _path, _rect2, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToiletDoorSlide = function SvgIcToiletDoorSlide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.657,
    height: 23.825,
    x: 11.703,
    y: 4.553,
    fill: "#67AEFF",
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4.234 28.378h24.03"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.928,
    height: 23.825,
    x: 5.898,
    y: 4.553,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.826 7.172c-.369-.366-.964-.083-.964.46V9.49h-3.33a1 1 0 0 0-1 1v1.751a1 1 0 0 0 1 1h3.33v2.1c0 .543.595.826.964.46l3.42-3.396a1.317 1.317 0 0 0 0-1.837z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.862 13.241h-3.33a1 1 0 0 1-1-1V10.49a1 1 0 0 1 1-1h3.33V7.632c0-.543.595-.826.964-.46l3.42 3.396a1.317 1.317 0 0 1 0 1.837l-3.42 3.396c-.369.366-.964.083-.964-.46zm-1.5 1.5v.6c0 .855.486 1.586 1.199 1.925.729.347 1.66.257 2.322-.4l3.42-3.396c1.089-1.08 1.089-2.886 0-3.967l-3.42-3.395a2.035 2.035 0 0 0-2.322-.401c-.713.34-1.2 1.07-1.2 1.925v.358h-1.83a2.5 2.5 0 0 0-2.5 2.5v1.751a2.5 2.5 0 0 0 2.5 2.5z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.008,
    cy: 16.466,
    r: 1.5,
    fill: "currentColor"
  })));
};
export default SvgIcToiletDoorSlide;